import React from 'react';
import PropTypes from "prop-types";

import {styled} from "@mui/material/styles";

import {ReactComponent as ArrowLeft} from "assets/img/wms/arrow-left.svg";
import {greyishBlue300} from "assets/jss/main";

ArrowLeftIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number,
};

const StyledSvg = styled(ArrowLeft)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            stroke: color
        },
        ...disabled === true &&  {
            stroke: greyishBlue300
        }
    },
}));

export default function ArrowLeftIcon(props) {
    return <StyledSvg {...props} />;
}
